// extracted by css-extract-rspack-plugin
export default {"icon":"product-detail-fragment__USPSliderMobile_icon__5K+4+","headline":"product-detail-fragment__USPSliderMobile_headline__agTtv"};